module.exports = __webpack_public_path__ + "static/media/hero.32e9c9b6.jpg";